import { formLabelClasses } from "../../styles/formClasses";
import { formComponentClasses } from "../../styles/componentClasses";
import { ErrorMessage } from "./ErrorMessage";

export function FormField(params: { label: any; error: any; children: any }) {
  return (
    <div className={formComponentClasses.field}>
      <label className={formLabelClasses}>{params.label}</label>
      {params.children}
      <ErrorMessage message={params.error} />
    </div>
  );
}
